import React from "react";
import pick from "lodash/pick";
import find from "lodash/find";
import omitBy from "lodash/omitBy";

import { getAllResultStateInfos, getSearchFilterByModelId, } from "~/stateGetter";
import { presentAppliedFilterValues, presentFilters } from "~/statePresenter";


import { VariadicRangeField } from "./VariadicRangeField";
import { IconButton, Dropdown, Box, HStack, VStack } from "~/native-ui";


import { connect, } from "~/redux/connect";
import { settingsActionCreator } from "~/actions/settingsActions";
import { getFilterType, getValueDefault, isDateFilter, range as rangeFilterType, date as dateFilterType } from "~/lib/filterTypes";



const isEmptyValue = (value) => {
    if (value !== 0 && !value) {
        return true;
    }

    if (Array.isArray(value)) {
        return value.length === 0
    }

    switch (typeof value) {
        case "object":
            return !(value.min || value.max);
        case "string":
            return !value;
        default:
            return false;
    }
}





const RenderSelectFilter = (() => {
    const mapStateToDropDownProps = (state, { modelId }) => {

        return {
            modelSearchFilter: getSearchFilterByModelId(state, modelId),
            ...pick(getAllResultStateInfos(state, modelId), "filterValues", "initialFilterValues", "filters", "parentPrimaryKey", "parentItemId", "parentItemValues", "parentSubview"),
        }
    }
    
    const mergePropsForDropdown = ({modelSearchFilter, ...stateProps}, dispatch, ownProps, ) => {
        let appliedFilters = presentAppliedFilterValues({ ...stateProps, takeAllCreatedFilters: true, }),
            filters = presentFilters({filters: stateProps.filters })
            filters = filters
                .filter(({ name, created_at }) => modelSearchFilter !== name && (name === ownProps.name || (!(name in appliedFilters) && !created_at)));

        return {
            ...ownProps,
            filters,
        }
    };

    class RenderSelectFilter extends React.PureComponent {
        state = {
            filterQuery: "",
        }

        handleQueryChange = (filterQuery) => {
            this.setState({ filterQuery })
        }

        getSource() {
            const { filterQuery } = this.state;
            const regex = filterQuery && new RegExp(filterQuery, "ig");
            return this.props.filters
                .map(({ name, title }) => ({ key: name, label: title }))
                .filter(({ label }) => !regex || regex.test(label))
        }
        
        getDropdownProps() {
            return {
                mt: "0",
                valueKey: "key",
                labelKey: "label",
                allowBlank: this.props.allowBlank,
                allowFiltering: true,
                value: this.props.name,
                source: this.getSource(),
                query: this.state.filterQuery,
                onChange: this.props.onChange,
                placeholder: this.props.trans(`filters.select_filter`),
                onQueryChange: this.handleQueryChange,
                filterHint: this.props.trans(`search`),
            }
        }

        render() {
            return (
                <Dropdown { ...this.getDropdownProps() } />
            );
        }

    }

    return  React.memo(
        connect(mapStateToDropDownProps, null, mergePropsForDropdown)(RenderSelectFilter)
    )
})()


export class VariadicFilterRow extends React.Component {
    state = {
        filterType: "",
        isSaveButtonEnabled: false,
        filterOptions: [],
    }

    constructor (props) {
        super(props);
        this.state = {
            filterOptions: this.getFilterOptions(),
            isSaveButtonEnabled: isEmptyValue(props.value),
            filterType: props.filterType || this.getFilterTypes()[0]?.name,
        };
    }

    static defaultProps = {
        autoApplyFilter: true,
    }

    componentDidMount() {
        if (!this.props.autoApplyFilter) { return; }
        if (!this.props.filterType) {
            const filterType = this.getFilterTypes()[0];
            isDateFilter(filterType?.name) && this.onChangeFilterType(filterType.name)
        }
    }

    onChangeFilterType = (filterType) => {
        if (this.props.filterType === filterType) { return; }
        const { name, getValue = getValueDefault } = find(this.getFilterTypes(), { name: filterType });
        this.setState({
            filterType: name,
            filterOptions: this.getFilterOptions(),
            isSaveButtonEnabled: isEmptyValue(getValue(this.props.value)),
        });

        // this.resetFilter?.(this.props.name, { filterType });
        this.onChange(getValue(this.props.value), filterType)
    }

    getFilterOptions (searchText = "") {
        const type = this.props.type || "text";
        const options = this.getFilterTypes().map(({ name }, i) => ({ label: this.props.trans(`filters.${type}.${name}`), key: name }));
        if (!searchText) { return options; }
    }


    onChange = (changeValue, filterType = this.state.filterType) => {
        if (changeValue === this.props.value) return;

        const { getValue = getValueDefault } = find(this.getFilterTypes(), { name: filterType });
        this.setState({
            isSaveButtonEnabled: isEmptyValue(getValue(changeValue)),
        });

        this.props.onChange?.(changeValue, filterType ?? this.state.filterType)
    }

    
    componentDidUpdate(props) {
        if(this.props.type !== props.type) {
            this.setState({
                filterOptions: this.getFilterOptions()
            }); 
        }


        if(!!this.props.isRange !== !!props.isRange) {
            this.setState({
                filterOptions: this.getFilterOptions()
            }); 
        }
    }


    /**
     * 
     * @returns Array of filters based on the field type;
     */
    getFilterTypes () {
        const { isRange, type } = this.props;
        return getFilterType(type) || (isRange ? rangeFilterType : getFilterType("text")) || [];
    }


    renderFilterType() {
        const { trans } = this.props;
        const fieldFilterType = this.getFilterTypes();

        if (fieldFilterType.length <= 0) {
            return null;
        }

        if (this.props.createFilter) {
            return null;
        }

        if (fieldFilterType.length === 1) {
            return this.state.filterOptions[0].label;
        }


        const dropdownProps = {
            mt: "0",
            valueKey: "key",
            labelKey: "label",
            allowFiltering: true,
            placeholder: trans("filters.select_filter"),
            value: this.props.filterType || "",
            source: this.state.filterOptions,
            onChange: this.onChangeFilterType,
            allowBlank: !this.props.filterType,
        }

        return (
            <Dropdown { ...dropdownProps } >
                {/* { fieldFilterType.map(({ name }, i) => <option selected={ name === this.state.filterType } value={i}>{ trans("filters." + name) }</option>) } */}
            </Dropdown>
        )
    }


    resetFilter(name, resetFilterProps) {
        this.props.onReset(name, resetFilterProps);
    }

    
    handleClearButtonClick = () => {
        this.resetFilter(this.props.name, { created_at: null, remove_filter: true, })
    }

    
    renderClearButton() {
        const iconProps = {
            p: "5px",
            size: "xs",
            width: "auto",
            height: "auto",
            value: "delete-forever",
            flexGrow: "0",
            flexShrink: "0",
            onClick: this.handleClearButtonClick,
            isDisabled: this.state.isSaveButtonEnabled,
        }

        if (this.props.createFilter) {
            return null;
        }

        return <IconButton { ...iconProps} />
    }


    onChangeFieldName = (filterName) => {
        if (this.props.name === filterName) {return;}
        if (this.props.name) { this.resetFilter(this.props.name, { created_at: null }); }
        this.resetFilter(filterName, { created_at: this.props.createFilter ? new Date().getTime() : this.props.created_at ?? this.props.defaultCreatedAt });
    }


    renderFieldSelection() {
        return <RenderSelectFilter allowBlank={!!this.props.createFilter} name={this.props.name} modelId={this.props.modelId} onChange={this.onChangeFieldName} />
    }


    renderField(component) {
        const { title, index, trans, isVariadicFilter, vertical } = this.props;

        const rowProps = {
            space: 2,
            w: "100%",
            alignItems: "center",
        }

        if (!isVariadicFilter) {
            return React.cloneElement(component, {
                title,
            })
        }

        if (vertical) {
            return (
                <VStack { ...rowProps } flex={1} w="250px" maxWidth="100%" aria-description="variadic-filter-row-vertical">
                    <Box width="100%" flexShrink="0">{ this.renderFilterType() }</Box>
                    <Box width="100%" flexShrink="0" flex={1}>{ component }</Box>
                </VStack>
            )
        }


        return (
            <HStack { ...rowProps } maxHeight="100%" flex={1} aria-description="variadic-filter-row">
                <Box width="10%" flexShrink="0">{ index === 0 ? trans("filters.where") : trans("filters.and") }</Box>
                <Box width="20%" flexShrink="0">{ this.renderFieldSelection() }</Box>
                <Box width="20%" flexShrink="0">{ this.renderFilterType() }</Box>
                <Box width="40%" flexShrink="0">{ component }</Box>
                { this.renderClearButton() }
            </HStack>
        )
    }


    render() {
        const { Component, isRange, title, index, onReset, isVariadicFilter, forwardRef, ...props } = this.props;


        if (rangeFilterType.find(({ name }) => this.state.filterType === name)) {
            return this.renderField(<VariadicRangeField Component={ Component } { ...props } ref={ forwardRef } filterType={this.state.filterType} onChange={this.onChange} />)
        }


        if (dateFilterType.find(({ name }) => this.state.filterType === name)) {
            return this.renderField(null)
        }


        return this.renderField(<Component ref={ forwardRef } { ...props } onChange={this.onChange} />)
    }
}

const mapDispatchToProps = (dispatch, { modelId, inputType, name, onChange, ...props }) => {
    const settingActions = settingsActionCreator(modelId);
   
    return {
        onChange: (value, filterType) => {
            dispatch(settingActions.updateFilter(
                name,
                value,
                omitBy({
                    filterType,
                    autoRemoveFilter: props.autoRemoveFilter,
                    defaultCreatedAt: props.defaultCreatedAt,
                }, x => x === undefined)))
            onChange?.(value, filterType);
        },
        onReset: (name, resetFilterProps) => dispatch(settingActions.resetFieldValue(name, resetFilterProps)),
    }
}

export const WithVariadicFilterRow = (FilterComponent) => connect(null, mapDispatchToProps, null, { forwardRef: true })(React.forwardRef((props, ref) => <VariadicFilterRow Component={ FilterComponent } { ...props } forwardRef={ref} /> ))
